module.exports = __webpack_public_path__ + "img/1-5.1374799d.png";